import Vue from 'vue';
import 'whatwg-fetch';
import vSelect from 'vue-select';
import vueWindowSize from 'vue-window-size';
import App from './App.vue';

Vue.config.productionTip = false;

Vue.component('v-select', vSelect);
Vue.use(vueWindowSize);

new Vue({
  render: (h) => h(App),
}).$mount('#kalender-app');
